var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileZip = function SvgFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M7.8.6h8.67c1.103 0 2.162.434 2.948 1.208l7.729 7.609A4.2 4.2 0 0 1 28.4 12.41V27.2a4.2 4.2 0 0 1-4.2 4.2H7.8a4.2 4.2 0 0 1-4.2-4.2V4.8A4.2 4.2 0 0 1 7.8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M18 1v6.8a3.2 3.2 0 0 0 3.2 3.2H28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D97706",
    d: "M0 17a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.315 22.882V24H3.317v-.986L6.634 18.8h-3.29v-1.117H8.28v.985l-3.3 4.215zm2.295-5.2V24H9.308v-6.318zm2.574 3.995V24H11.88v-6.318h2.596c1.452 0 2.359.686 2.359 1.997 0 1.303-.907 1.998-2.359 1.998zm0-1.1h1.223c.757 0 1.144-.335 1.144-.898 0-.572-.387-.897-1.144-.897h-1.223z"
  })));
};
export default SvgFileZip;